module.exports = __webpack_public_path__ + "img/pgxz.f8c6aa72.png";